import { createSelector } from 'reselect'
import { keys, reduce } from 'lodash-es'

export const selectCurrentTab = state => state.panel.name

export const selectGlobe = state => state.panel.globe

export const selectLayerGroup = createSelector(
    selectGlobe,
    (globe) => keys(globe)
)

export const selectLayers = createSelector(
    selectGlobe,
    (globe) => reduce(globe, (result, value, key) => {
        const r = result.concat(value)
        return r
    }, [])
)

export const selectCurrentCO2 = state => state.timeline.currentCO2

export const selectShipType = state => state.timeline.shipType

export const selectYear = state => state.timeline.currentYear

export const selectMonth = state => state.timeline.currentMonth

export const selectDay = state => state.timeline.currentDay

export const selectCategory = state => state.timeline.category

export const selectCurrentLayerGroup = state => state.timeline.currentLayerGroup

export const selectDrawerShow = state => state.panel.drawerShow

export const selectPanels = state => state.dashboard.panels

export const selectPanelsByLayerGroup = createSelector(
    selectPanels, selectCurrentLayerGroup,
    (panels, layerGroup) => panels[layerGroup]
)

export const selectVisibleDashboardPanels = createSelector(
    selectPanelsByLayerGroup,
    (panels) => {
        const visibleDashboardPanels = reduce(panels, (result, value, key) => {
            if (value && (key !== 'risk' && key !== 'buffer')) {
                result.push(key)
            }
            return result
        }, [])
        return visibleDashboardPanels
    }
)

export const selectDrawPolygon = state => state.panel.drawPolygon
export const selectVertex = state => state.panel.vertex
export const selectTemperaturePoint = state => state.panel.temperature
export const selectUser = state => state.user.user
export const selectOperationVersion = state => state.panel.operationVersion
export const selectOperationStatus = state => state.panel.operationStatus